import { render, staticRenderFns } from "./EmailAddressList.vue?vue&type=template&id=bc5fb480&scoped=true&"
import script from "./EmailAddressList.vue?vue&type=script&lang=js&"
export * from "./EmailAddressList.vue?vue&type=script&lang=js&"
import style0 from "./EmailAddressList.vue?vue&type=style&index=0&id=bc5fb480&lang=scss&scoped=true&"
import style1 from "./EmailAddressList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5fb480",
  null
  
)

export default component.exports